import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doSwitchSubscription),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(watchPlanConfirmationModalSagas);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { defineMessages } from 'react-intl';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { fetchEntity, fetchEntityIfNeeded } from '@classpass/saga-tools';
import { replace as replacePath } from 'react-router-redux';
import { getUserLocation, getUserId } from 'redux/saga/helpers';
import { deepExtract } from 'helpers/deep';
import { ec } from 'helpers/multitrack';
import { createSubscription, planById, userSubscription } from 'redux/saga/entities/bound';
import { toggleFlag } from 'redux/modules/page';
import { EFFECTIVE_NEXT_CYCLE } from 'constants/plan-change-effective-dates';
import { addSuccessNotification } from 'features/Banners/Banners.reducer';
import { hideModal } from 'redux/modules/modals';
export var messages = defineMessages({
  planChangeSuccess: {
    id: 'planConfirmation.modal.planChange.success',
    defaultMessage: 'Success! Your plan change has been confirmed.'
  }
});
export var LEAVING_PAGE_FLAG = 'LEAVING_PAGE';
export var ERROR_NO_PAYMENT_SOURCE = 4315;
export var SWITCH_SUBSCRIPTION = 'PLAN_CONFIRMATION_MODAL.SWITCH_SUBSCRIPTION';
export var switchSubscription = function switchSubscription(subscriptionData) {
  return {
    type: SWITCH_SUBSCRIPTION,
    subscriptionData: subscriptionData
  };
};
export function doSwitchSubscription(client, _ref) {
  var subscriptionData, newPlanId, effective, _subscriptionData$tra, trackingData, userId, _ref2, _ref3, currentSubscription, newPlan, activeLocation;

  return regeneratorRuntime.wrap(function doSwitchSubscription$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          subscriptionData = _ref.subscriptionData;
          _context.prev = 1;
          newPlanId = subscriptionData.newPlanId, effective = subscriptionData.effective, _subscriptionData$tra = subscriptionData.trackingData, trackingData = _subscriptionData$tra === void 0 ? {} : _subscriptionData$tra;
          _context.next = 5;
          return call(getUserId);

        case 5:
          userId = _context.sent;
          _context.next = 8;
          return all([call(fetchEntityIfNeeded, userSubscription, [client, userId]), call(fetchEntityIfNeeded, planById, [client, newPlanId]), call(getUserLocation, client), put(toggleFlag(LEAVING_PAGE_FLAG))]);

        case 8:
          _ref2 = _context.sent;
          _ref3 = _slicedToArray(_ref2, 3);
          currentSubscription = _ref3[0].current_subscription;
          newPlan = _ref3[1];
          activeLocation = _ref3[2];
          _context.next = 15;
          return call(fetchEntity, createSubscription, [client, {
            userId: userId,
            msaId: newPlan.msa_id,
            planId: newPlan.id,
            effective: effective || EFFECTIVE_NEXT_CYCLE,
            locationId: deepExtract('location.id', activeLocation)
          }]);

        case 15:
          _context.next = 17;
          return call(ec, 'Manage Membership - Complete', _objectSpread({
            page_type: 'plan_switching',
            action: 'confirm_plan',
            pending_plan_id: newPlan.id,
            pending_plan_code: newPlan.plan_code,
            current_plan_id: currentSubscription.plan.id,
            current_plan_code: currentSubscription.plan.plan_code,
            plan_change_type: effective
          }, trackingData));

        case 17:
          _context.next = 19;
          return all([put(hideModal('PlanConfirmationModal')), put(addSuccessNotification(messages.planChangeSuccess, {
            removeAfterNavigations: 2,
            timeout: 0
          })), put(replacePath('/settings/membership'))]);

        case 19:
          _context.next = 25;
          break;

        case 21:
          _context.prev = 21;
          _context.t0 = _context["catch"](1);
          _context.next = 25;
          return put(toggleFlag(LEAVING_PAGE_FLAG));

        case 25:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 21]]);
}
export function watchPlanConfirmationModalSagas(client) {
  return regeneratorRuntime.wrap(function watchPlanConfirmationModalSagas$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return fork(takeEvery, switchSubscription().type, doSwitchSubscription, client);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}